var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C6.20907 0 8 1.79093 8 4C8 6.20907 6.20907 8 4 8C1.79093 8 0 6.20907 0 4C0 1.79093 1.79093 0 4 0ZM4 3.11111C3.75452 3.11111 3.55556 3.31007 3.55556 3.55556V6.31111C3.55556 6.5566 3.75452 6.75556 4 6.75556C4.24548 6.75556 4.44444 6.5566 4.44444 6.31111V3.55556C4.44444 3.31007 4.24548 3.11111 4 3.11111ZM4 1.24444C3.65625 1.24444 3.37778 1.52292 3.37778 1.86667C3.37778 2.21042 3.65625 2.48889 4 2.48889C4.34375 2.48889 4.62222 2.21042 4.62222 1.86667C4.62222 1.52292 4.34375 1.24444 4 1.24444Z",
    fill: "#A0ACB9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.3220c93ade9c6b6c617e1b0a74040bd4.svg";
export { ForwardRef as ReactComponent };